// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2JnG-","inner":"Footer_inner__18ULJ"};